import { styled } from '@mui/system';
import { TableCell } from '@mui/material';

export const StyledTableCell = styled(TableCell)`
  text-align: center;
  color: #ffffff;
`;

